var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 165,
    viewBox: "0 0 147 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 164.354V154.354C104.043 151.026 111.461 145.496 117.266 138.089C121.343 144.823 123.693 153.131 123.972 162.831C124.003 163.92 123.094 164.817 122.005 164.838C110.159 165.063 101.431 165.171 95 164.354Z",
    className: "HairDark"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.289 151.006C113.022 144.996 120.925 135.305 126.024 122.679C127.123 122.89 128.256 123 129.415 123C129.753 123 130.083 122.991 130.406 122.972C136.239 130.321 139.633 140.05 139.972 151.831C140.003 152.92 139.094 153.817 138.005 153.838C119.597 154.188 108.718 154.255 102.289 151.006Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3077 138.809C34.8058 145.585 41.7001 150.727 50.0001 153.975V164.572C43.7917 165.148 35.6561 165.04 24.9951 164.838C23.9058 164.817 22.9968 163.92 23.0282 162.831C23.2974 153.474 25.4934 145.412 29.3077 138.809Z",
    className: "HairDark"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5714 123C16.5759 123 16.5804 123 16.585 123C17.7434 123 18.8769 122.89 19.976 122.679C25.1487 135.487 33.2063 145.275 44.1767 151.263C37.6848 154.251 26.9027 154.178 8.99511 153.838C7.90579 153.817 6.99682 152.92 7.02815 151.831C7.36669 140.064 10.7523 130.345 16.5714 123Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133 81.3062C133 82.6827 132.982 84.045 132.947 85.3928C134.072 85.6624 135.086 86.0659 135.997 86.5882C135.957 45.6744 135.117 31.0942 117.664 27.7851C127.91 39.8175 133 57.808 133 81.3062Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0749 33.5976C16.6784 45.3361 13.0004 61.3312 13.0004 81.3062C13.0004 82.6827 13.0178 84.0451 13.0528 85.3929C11.5024 85.7645 10.1617 86.3906 9.01075 87.232C9.11792 52.2203 10.3316 37.9692 24.0749 33.5976Z",
    className: "Hair"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0047 53.9663C37.6083 53.0666 55.2852 34.1692 55.9788 2.19607C56.0024 1.10905 55.0977 0.210291 54.0107 0.186554C9.57505 -0.783791 9.00735 0.134657 9.0001 51.9622C8.99994 53.0667 9.90072 54.0037 11.0047 53.9663Z",
    className: "Hair"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.916 23.9871C42.876 23.6218 30.1185 15.5523 29.0067 2.78662C28.9152 1.73677 29.7726 0.85666 30.8243 0.789779C59.9292 -1.0611 68.991 -0.229539 71.7526 9.54844C74.0364 -0.248494 82.6353 -1.06428 115.011 0.800582C116.069 0.861466 116.94 1.74434 116.832 2.79761C115.525 15.5542 100.738 23.6185 72.9356 23.9868C72.5683 23.9917 72.2232 23.8953 71.926 23.724C71.6287 23.8954 71.2833 23.9918 70.916 23.9871Z",
    className: "Hair"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.995 53.9664C107.386 53.0693 89.7074 34.2232 89.0207 2.33765C88.9976 1.26113 89.8838 0.366528 90.9599 0.328938C133.723 -1.16484 135.949 0.306495 135.999 51.9627C136 53.0672 135.099 54.0037 133.995 53.9664Z",
    className: "Hair"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77318 54.712C11.2232 59.1462 21.1676 55.7946 28.2277 44.8025C28.8089 43.8975 28.5073 42.6971 27.5949 42.1277C13.2875 33.1987 11.7628 33.5223 1.00457 52.0488C0.449892 53.004 0.773221 54.2428 1.77318 54.712Z",
    className: "Hair"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.547 54.712C135.097 59.1462 125.153 55.7946 118.093 44.8025C117.511 43.8975 117.813 42.6971 118.725 42.1277C133.033 33.1987 134.558 33.5223 145.316 52.0488C145.87 53.004 145.547 54.2428 144.547 54.712Z",
    className: "Hair"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5401 32.1253C6.82573 32.7161 5.8677 40.275 8.4634 39.9107C32.138 36.5878 104.925 32.7373 137.221 39.9107C141.893 40.9484 139.817 32.6117 137.221 32.1253C112.3 27.4566 33.3836 28.4919 10.5401 32.1253Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairX);
export default __webpack_public_path__ + "static/media/Hair X.08cefd1d7515732ec4224b071c05a419.svg";
export { ForwardRef as ReactComponent };